import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { scrollToRef } from '../../../../utils';

import Text, { TextTypes } from '../../Text';

const NavigationItem = ({ styles, rules, reference, isLast, title, active, itemsVisible }) => {
    const handleClick = () => {
        scrollToRef(reference);
    };

    const { formatMessage } = useIntl();

    const label = formatMessage({ id: 'sectionNavigation.button.aria.label' });
    const buttonName = formatMessage({ id: title });

    return (
        <>
            <div
                onClick={handleClick}
                role="button"
                aria-label={label}
                onKeyDown={handleClick}
                tabIndex="0"
                className={styles.container}
            >
                <div className={styles.buttonContainer} role="button" aria-label={buttonName} tabIndex="0">
                    <div className={styles.inner} />
                </div>
                <Text itemsVisible={itemsVisible} extend={rules.extendText} active={active} type={TextTypes.SECTION}>
                    <FormattedMessage id={title} />
                </Text>
            </div>
            {!isLast && <div className={styles.divider} />}
        </>
    );
};

NavigationItem.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    reference: PropTypes.shape().isRequired,
    isLast: PropTypes.bool.isRequired,
    context: PropTypes.shape().isRequired,
    setContext: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    itemsVisible: PropTypes.bool.isRequired,
};

export default NavigationItem;
